module.exports = __webpack_public_path__ + "static/media/temperature-high.69b2163b.svg";